<div class="picklist-list-item__wrapper p-5">
  <div class="flex align-items-center gap-3">
    <div class="grow flex align-items-center">
      <button
        class="page-header__back"
        [routerLink]="['/shipping/picklists/', currentId]"
      >
        <i class="fa fa-angle-left"></i>
      </button>
      <h3 class="mb-0">Visual Picking</h3>
    </div>
    <div class="flex gap-2 mr-6">
      Stock Location:
      <span class="text-purple-700 font-semi-bold"
        >wip-location-{{ currentId }}</span
      >
    </div>
    <div class="flex gap-2">
      Sales Order Number(s):
      <div class="picklist-list-item__orderNumber">
        <ng-container
          *ngFor="let order of orders; let i = index; trackBy: trackByValue"
        >
          <a
            *ngIf="i < orderNumberMaxDisplay"
            target="_blank"
            [routerLink]="['/shipping/posted-orders']"
            [queryParams]="{ orderNumber: order.orderNumber }"
          >
            {{ order.orderNumber }}
          </a>
          <span *nfIf="order.orderStatus == 'on_hold'">{{
            order.orderStatus
          }}</span>
        </ng-container>

        <span *ngIf="orderNumbers.length > 4" class="text-underline cursor-pointer">
          <span
            *ngIf="orderNumberMaxDisplay === 4; else showLess"
            (click)="orderNumberMaxDisplay = orderNumbers.length"
          >
            Show more({{ orderNumbers.length - 4 }})
          </span>
          <ng-template #showLess
            ><span (click)="orderNumberMaxDisplay = 4">
              Show less
            </span></ng-template
          >
        </span>
      </div>
    </div>
  </div>
  <mat-divider class="mb-4 mt-2"></mat-divider>
  <lum-picklist-item-filters
    class="mb-2"
    (searchEvent)="onSearchEvent($event)"
  ></lum-picklist-item-filters>
  <div class="flex justify-content-end align-items-center gap-3">
    <ng-container *ngIf="checkedItems > 0">
      <button
        *ngIf="checkedItemsForPick.length > 0"
        type="button"
        class="lum-button lum-button--secondary pr-5"
        mat-button
        [disabled]="!canUpdateCheckedItemsForPick"
        (click)="onMultiplePickEvent()"
      >
        Pick selected items ({{ checkedItemsForPick.length }})
        <i class="fas fa-check-circle pl-1"></i>
      </button>
      <button
        *ngIf="checkedItemsForDone.length > 0"
        type="button"
        class="lum-button lum-button--primary pr-5"
        mat-button
        [disabled]="!canUpdateCheckedItemsForDone"
        (click)="onMultipleDoneEvent()"
      >
        Done selected items ({{ checkedItemsForDone.length }})
        <i class="fas fa-check-circle pl-1"></i>
      </button>
      <button
        *ngIf="checkedItemsForReset.length > 0"
        type="button"
        class="lum-button lum-button--primary pr-5"
        mat-button
        [disabled]="!canUpdateCheckedItemsForReset"
        (click)="onMultipleResetEvent()"
      >
        Reset selected items ({{ checkedItemsForReset.length }})
        <i class="fas fa-check-circle pl-1"></i>
      </button>
    </ng-container>

    <button
      mat-button
      class="lum-button lum-button--secondary"
      [matMenuTriggerFor]="bulkMenu"
    >
      <lum-ui-icon class="pr-1 pb-1" icon="menu" color="#5563d6"></lum-ui-icon>
      Actions
    </button>
    <mat-menu #bulkMenu="matMenu">
      <button mat-menu-item [disabled]="loading" (click)="printShippingLabels()">
        <lum-ui-icon
          class="pr-1 pb-1"
          icon="file-add"
          color="#5563d6"
        ></lum-ui-icon>
        Print Shipping Labels
      </button>
    </mat-menu>
  </div>
  <div class="picklist-list-item__table">
    <lum-picklist-item-table
      *ngIf="(currentPicklistItems$ | async)?.length"
      [items]="(currentPicklistItems$ | async) || []"
      [currentPickListStatus]="
        (currentPicklist$ | async)?.status || picklistStatus.CREATED
      "
      [dataSource]="dataSource"
      [rows]="formRows"
      [locations]="locations"
      [lots]="lots"
      [loadingLocations]="(loadingLocations$ | async) || false"
      [loadingLots]="(loadingLots$ | async) || false"
      [submittingForm]="(submittingForm$ | async) || savingItems"
      [loading]="(loading$ | async) || false"
      [form]="form"
      [draftItems]="draftItems"
      [hasLotTracking]="hasLotTracking"
      [sortDirection]="queryParams['sortDirection']"
      (pickEvent)="onPickEvent($event)"
      (doneEvent)="onDoneEvent($event)"
      (resetEvent)="onResetEvent($event)"
      (splitEvent)="onSplitEvent($event)"
      (openLocationListEvent)="fetchLocations($event)"
      (openLotListEvent)="fetchLots($event)"
      (selectLocationEvent)="onSelectLocationEvent($event)"
      (selectLotEvent)="onSelectLotEvent($event)"
      (removeItemEvent)="onRemoveItemEvent($event)"
      (showSkuDetailEvent)="onShowSkuDetailEvent($event)"
      (sortEvent)="onSortEvent($event)"
    ></lum-picklist-item-table>
  </div>

  <!-- <mat-paginator
    [length]="(pagination$ | async)?.total"
    [pageSize]="(pagination$ | async)?.per_page"
    [pageSizeOptions]="paginationConfig.pageSizeOptions"
    [pageIndex]="((pagination$ | async)?.current_page || 1) - 1"
    (page)="onPaginationEvent($event)"
    aria-label="Select page"
  >
  </mat-paginator> -->
  <div class="flex mt-4">
    <div class="grow">
      <lum-ui-label
        label="
        Total # of items Picked: {{ itemPickedCount | decimalPlaces }}/{{
          (currentPicklist$ | async)?.totalUnits || 0 | decimalPlaces
        }}"
        cssClasses="text-purple-700 bg-purple-200"
      ></lum-ui-label>
    </div>
    <div class="flex gap-3">
      <button
        *ngIf="canSaveItems"
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        [disabled]="!hasInProgressOrPickedItems"
        (click)="onSave()"
      >
        <lum-ui-icon
          class="pr-1 pb-1"
          icon="content-save"
          color="#5563D6"
          width="15"
          height="15"
        ></lum-ui-icon>
        Save
      </button>
      <button
        *ngIf="currentPicklist?.status !== picklistStatus.SHIPPED"
        type="button"
        class="lum-button lum-button--primary"
        mat-button
        [loading]="(submittingForm$ | async) || pickFinishLoading || false"
        [disabled]="itemPickedCount <= 0 || pickFinishLoading"
        (click)="onShip()"
      >
        <lum-ui-icon
          class="pr-1 pb-1"
          icon="shipping"
          color="#ffffff"
          width="23"
          height="23"
        ></lum-ui-icon>
        Finish
      </button>
    </div>
  </div>
</div>
